import React, { useCallback, useEffect } from 'react';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonCard, IonCardContent, IonButton, IonIcon } from '@ionic/react';
import { useDropzone } from 'react-dropzone';
import './DragAndDrop.css';
import { useGlobalStore } from './stateManagement/globalZustand';
import { _dict } from './constants';
import { getValidPecs } from '../foo/converter';
import { useHistory, useLocation } from 'react-router';
import { useUIStore } from './stateManagement/UIZustand';
import { arrowBack } from 'ionicons/icons';
import { useURLStore } from './stateManagement/URLZustand';

const DragAndDrop: React.FC = () => {
  const { lang, setClipboardPecs, setIsParentMode} = useGlobalStore();
  const [ error, setError ] = React.useState<string | undefined>(undefined);
  const { setIsChoiceDialogOpen } = useUIStore();
  const { getURLTo } = useURLStore();

  const history = useHistory();
/*
  const location = useLocation();



const handleSharedContent = useCallback(async () => {
  try {
    const sharedFile = location.state as File; // Assuming the file is directly under location.state

    if (!sharedFile) {
      setError(_dict.errorImportingContent[lang]);
      return;
    }
 
    const validPecs = await getValidPecs([sharedFile]);
    const pecs = validPecs[0];

    if (!pecs) {
      setError(_dict.errorImportingContent[lang]);
      return;
    }

    setClipboardPecs(pecs);
    history.push(getURLTo().talkFromNodePath());
    setIsParentMode(true);
    setIsChoiceDialogOpen(false);
  } catch (error) {
    console.error('Error handling shared content:', error);
    setError(_dict.errorImportingContent[lang]);
  }
}, [location.state, lang, setClipboardPecs, history, getURLTo, setIsParentMode, setIsChoiceDialogOpen]);

useEffect(() => {
  if (location.state) {
    handleSharedContent();
  }
}, [location.state, handleSharedContent]);
*/

  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    const validPecs = await getValidPecs(acceptedFiles);
    let pecs = validPecs[0];
    //const entries = await Promise.all(Object.entries(pecs.l2Image).map(async ([k, v]) => [k, await compressImageBeforeImport(v as string)]));
    //pecs.l2Image = Object.fromEntries(entries);
    if(pecs === undefined) {
      setError(_dict.errorImportingContent[lang]);
      return;
    }
    setClipboardPecs(pecs);
    history.push(getURLTo().talkFromNodePath());
    setIsParentMode(true);
    setIsChoiceDialogOpen(false);
}, []);

const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop: onDrop, multiple: false });

  if(error !== undefined) {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar className="ion-text-center">
            <IonTitle>{error}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <IonButton
                onClick={() => {history.push(getURLTo().talkFromNodePath())}}
                style={{height:"60px", width:'fit-content'}} color="light">
                    <IonIcon icon={arrowBack} slot="start" size="large" />
                    {_dict.back[lang]}
            </IonButton>
          </div>
        </IonContent>
      </IonPage>
    );
  }

  
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar className="ion-text-center">
          <IonTitle>{_dict.uploadPecs[lang]}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <IonCard {...getRootProps()} className={`dropzone ${isDragActive ? 'active' : ''}`}>
          <input {...getInputProps()} />
          <IonCardContent>
            {
              isDragActive ?
                <p>{_dict.dropFilesHere[lang]}</p> :
                <p>{_dict.dragAndDropFilesHereOrClickToSelect[lang]}</p>
            }
            
          </IonCardContent>
          
        </IonCard>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <IonButton
              onClick={() => {history.push(getURLTo().talkFromNodePath())}}
              style={{height:"60px", width:'fit-content'}} color="light">
                  <IonIcon icon={arrowBack} slot="start" size="large" />
                  {_dict.back[lang]}
          </IonButton>
        </div>
 
      </IonContent>
    </IonPage>
  );
};

export default DragAndDrop;
